module.exports = __webpack_public_path__ + "img/intercom_even.2a74f144.svg";